const SITE_URL = "https://www.hitechtransit.com";
const PHONE = "07346 209593";
const EMAIL = "hello@hitechtransit.com";

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Hitech Transit",
  legalName: "Hitech Transit Limited",
  url: SITE_URL,
  telephone: PHONE,
  email: EMAIL,
  logo: `${SITE_URL}/logo.png`,
  sameAs: [
    "https://facebook.com/hitechtransit",
    "https://instagram.com/hitechtransit",
    "https://twitter.com/hitechtransit",
  ],
  address: {
    "@type": "PostalAddress",
    addressLocality: "Cardiff",
    addressRegion: "Wales",
    addressCountry: "GB",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: PHONE,
    contactType: "customer service",
    availableLanguage: "English",
  },
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "MovingCompany",
  name: "Hitech Transit",
  image: "https://static.prod-images.emergentagent.com/jobs/80ea756f-7ea3-4803-b754-18b59043e07a/images/d9b70dc68cc964050d6b7582cabdba6cd06668dbb9ef9a403050982926bf0037.png",
  url: SITE_URL,
  telephone: PHONE,
  email: EMAIL,
  priceRange: "££",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Cardiff",
    addressRegion: "Wales",
    postalCode: "CF",
    addressCountry: "GB",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 51.4816,
    longitude: -3.1791,
  },
  areaServed: [
    { "@type": "City", name: "Cardiff" },
    { "@type": "City", name: "Newport" },
    { "@type": "City", name: "Swansea" },
    { "@type": "City", name: "Bristol" },
    { "@type": "City", name: "London" },
    { "@type": "AdministrativeArea", name: "South Wales" },
  ],
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      opens: "07:00",
      closes: "20:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Sunday",
      opens: "09:00",
      closes: "17:00",
    },
  ],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.9",
    reviewCount: "500",
    bestRating: "5",
  },
};

export const createServiceSchema = (name, description, url) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  url: `${SITE_URL}${url}`,
  provider: {
    "@type": "MovingCompany",
    name: "Hitech Transit",
    url: SITE_URL,
  },
  areaServed: {
    "@type": "AdministrativeArea",
    name: "South Wales and England",
  },
  serviceType: "Moving Service",
});

export const createFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((faq) => ({
    "@type": "Question",
    name: faq.q,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.a,
    },
  })),
});
